import React, { Suspense, lazy } from 'react';
import { ApolloProvider } from '@apollo/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { client } from '../client';
import { store, persistor } from '../redux/store';
import { ThemeProvider } from '../theme/ThemeContext';

// Move CSS imports here so the lightweight wrapper stays tiny
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/global.module.css';

// Lazily load heavy subtrees to enable further chunk-splitting
const AtunwaPlayerMeta = lazy(() => import('./AtunwaPlayerMeta'));
const AtunwaPlayerBundle = lazy(() => import('./AtunwaPlayerBundle/AtunwaPlayerBundle'));

const RootApp = ({ dev }: { dev?: boolean }) => (
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={"loading"}>
      <ApolloProvider client={client}>
        <ThemeProvider>
          <div id="atunwa-player" className="atunwa-player">
            {/*<ConsoleLogger dev={dev} />*/}
            {/*<ThemeToggle/>*/}
            {/*<CollapseToggle/>*/}
            <Suspense fallback={null}>
              <AtunwaPlayerMeta />
            </Suspense>
            <Suspense fallback={null}>
              <AtunwaPlayerBundle />
            </Suspense>
          </div>
        </ThemeProvider>
      </ApolloProvider>
    </PersistGate>
  </Provider>
);

export default RootApp;
